import axiosClient from "./axiosClient";

export const getOrganizationById = async (organizationId) => {
  try {
    const response = await axiosClient.get(`/getOrganizations/${organizationId}`);
    return response.data.organization;
  } catch (error) {
    console.error("Error fetching organization:", error);
    throw error;
  }
};
